import useSWR from "swr";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";

export function useKnownRefundAcTags() {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();
  const { data, isLoading } = useSWR(
    "/product/ac-tags/known-refund-tags",
    async (url) => {
      const { data } = await createAxiosInstance().get<string[]>(url);
      return data;
    },
  );

  return {
    refundTags: data ?? [],
    isLoading,
  };
}
